import React from 'react'

import { TextField, TextFieldProps } from '../TextField'

export interface DecimalFieldProps extends TextFieldProps {
  precisao?: number
}

DecimalField.defaultProps = {
  precisao: 2,
}

export function DecimalField(props: DecimalFieldProps) {
  const { precisao, ...rest } = props

  const pattern = new RegExp(`^\\d+(,\\d{0,${precisao}})?$`)
  const parse = (value: string) => (value.match(pattern) ? value : value.substr(0, value.length - 1))

  return <TextField parse={parse} {...rest} />
}
